import { axiosInterceptor } from "../utils/request.js"
import zkRouter from "../config/zkRouter.js"
import { sessionStorage } from '../utils/storage'
import { USER_INFO } from '../utils/enum'

let AXIOS_INIT = false

export default {
  data() {
    return {
      winPageData: window.WinPageData,
      // userInfo: {
      //   token: window.WinPageData['csrf_token'] || ''
      // }
    }
  },
  created() {
    if (!AXIOS_INIT) {
      axiosInterceptor.call(this)
      AXIOS_INIT = true
    }
  },
  computed: {
    isDevEnv() {
      return process.env.NODE_ENV == 'development'
    }
  },
  methods: {
    /**
     * @description: 用法与vue route 一致
     * @param {object} options 路由名
     * @return {string}
     */    
    pushRoute(options) {
      zkRouter.push(options)
    },
    /**
     * @description: 获取路由地址
     * @param {object} options
     * @return {string}
     */  
    getRoute(options) {
      return zkRouter.getRoute(options)
    },
    // goPage(name, queryObj = {}, isOpen = true) {
    //   let _queryObj = Object.assign({}, queryObj)
    //   let hashObj = null
    //   if (_queryObj.hash) {
    //     hashObj = _queryObj.hash
    //     delete _queryObj.hash
    //   }
    //   let url = pages.getUrl(name, _queryObj)
    //   if(hashObj) {
    //     let hashStr = queryStringify(hashObj).replace('&', '#')
    //     url += hashStr
    //   }
    //   if (isOpen) {
    //     window.open(url)
    //   } else {
    //     window.location.href = url
    //   }
    // },
    // goHashPage(name, queryObj = {}, isOpen = true) {
    //   const url = pages.getUrl(name, queryObj)
    //   if (isOpen) {
    //     window.open(url)
    //   } else {
    //     window.location.href = url
    //   }
    // },
    _setSessionToken() {
      // const isExist = localStorage.isExistItem('USER_INFO')
      // if(isExist) return
      sessionStorage.setItem(USER_INFO, this.winPageData.csrf_token)
    }
  }
}



// WEBPACK FOOTER //
// ./pc/yiqijian-video/mixins/index.js